import { v2 } from '@google-cloud/translate';

export const validateApiKey = async (key: string) => {
  const from = 'en';
  const to = 'fr';
  const textToTranslate = 'Hello this is Test';
  try {
    const googleTranslateV2 = new v2.Translate({
      key,
    });
    await googleTranslateV2.translate(textToTranslate, {
      from,
      to,
    });
    return true;
  } catch {
    return false;
  }
};
